	(function () {
		var sliderElement = document.querySelector('#holiday_2026--concept .holiday-2026-concept-slider');

		if (!sliderElement || typeof Swiper === 'undefined') {
			return;
		}

		new Swiper(sliderElement, {
			loop: true,
			effect: 'fade',
			fadeEffect: {
				crossFade: false
			},
			speed: 800,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false
			}
		});
	})();

	(function () {
		var holidayPage = document.querySelector('#holiday-2026-page');

		if (!holidayPage || typeof Swiper === 'undefined') {
			return;
		}

		function initSlider(slider) {
			if (!slider) {
				return;
			}

			if (slider.swiper) {
				slider.swiper.update();
				return;
			}

			new Swiper(slider, {
				breakpoints: {
					0: {
						slidesPerView: 2,
						spaceBetween: 20
					},
					768: {
						slidesPerView: 3,
						spaceBetween: 24
					},
					1280: {
						slidesPerView: 4,
						spaceBetween: 48
					}
				},
				navigation: {
					nextEl: slider.querySelector('.next'),
					prevEl: slider.querySelector('.prev')
				},
				preventClicks: true,
				preventClicksPropagation: true,
				scrollbar: {
					el: slider.querySelector('.scrollbar'),
					draggable: true
				},
				slideClass: 'slide',
				wrapperClass: 'wrapper'
			});
		}

		holidayPage.querySelectorAll('.horizon-slider').forEach(function (slider) {
			if (!slider.closest('.prices2026')) {
				initSlider(slider);
			}
		});

		var prices = holidayPage.querySelector('.prices2026');

		if (!prices) {
			return;
		}

		var inputs = prices.querySelectorAll('.buttons input[name="release"]');
		var containers = prices.querySelectorAll('.container[data-collection]');

		if (!inputs.length || !containers.length) {
			return;
		}

		function switchCollection(selectedInput) {
			containers.forEach(function (container) {
				var isActive = container.dataset.collection === selectedInput.value;
				container.hidden = !isActive;

				if (isActive) {
					requestAnimationFrame(function () {
						initSlider(container.querySelector('.horizon-slider'));
					});
				}
			});
		}

		inputs.forEach(function (input) {
			input.addEventListener('change', function () {
				switchCollection(input);
			});
		});

		var checkedInput = prices.querySelector('.buttons input[name="release"]:checked') || inputs[0];
		checkedInput.checked = true;
		switchCollection(checkedInput);
	})();

	(function () {
		var buttons = document.querySelectorAll('#holiday-2026-page [data-cartin]');

		buttons.forEach(function (button) {
			button.addEventListener('click', function (event) {
				event.preventDefault();

				if (typeof addToCartButton !== 'function') {
					console.error('addToCartButton is not available.');
					return;
				}

				addToCartButton(
					button.dataset.cartinProductId,
					button.dataset.cartin,
					button.dataset.cartinImage,
					button.dataset.cartinName,
					event,
					button
				);
			});
		});
	})();

	(function () {
		var holidayPage = document.querySelector('#holiday-2026-page');

		if (!holidayPage) {
			return;
		}

		var activeModal = null;
		var activeTrigger = null;

		function closeModal(modal) {
			modal.classList.add('hide');
			modal.setAttribute('aria-hidden', 'true');

			if (modal === activeModal) {
				activeModal = null;

				if (activeTrigger) {
					activeTrigger.focus();
					activeTrigger = null;
				}
			}
		}

		holidayPage.querySelectorAll('[data-modal]').forEach(function (trigger) {
			var modal = document.getElementById(trigger.dataset.modal);

			if (!modal || !modal.classList.contains('holiday_2026-modal')) {
				return;
			}

			trigger.addEventListener('click', function (event) {
				event.preventDefault();
				activeModal = modal;
				activeTrigger = trigger;
				modal.classList.remove('hide');
				modal.setAttribute('aria-hidden', 'false');

				var swiperElement = modal.querySelector('.swiper');
				if (swiperElement && swiperElement.swiper) {
					swiperElement.swiper.update();
				}
			});
		});

		holidayPage.querySelectorAll('.holiday_2026-modal').forEach(function (modal) {
			modal.setAttribute('aria-hidden', modal.classList.contains('hide') ? 'true' : 'false');

			modal.querySelectorAll('[data-close]').forEach(function (button) {
				button.addEventListener('click', function (event) {
					event.preventDefault();
					closeModal(modal);
				});
			});
		});

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && activeModal) {
				closeModal(activeModal);
			}
		});
	})();
